import * as React from "react"

import { cn } from "@/lib/utils"

/** Плейсхолдер загрузки: muted-прямоугольник с пульсацией. Размер — классами (h-4 w-32 …). */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden className={cn("animate-pulse rounded-lg bg-muted", className)} {...props} />
}

export { Skeleton }
